<template>
  <v-dialog
    :value="value"
    max-width="980"
    persistent
    @input="$emit('input', $event)"
  >
    <v-card class="help-video-dialog">
      <button
        class="help-video-dialog__close"
        type="button"
        aria-label="Fechar vídeo de ajuda"
        @click="close"
      >
        <v-icon size="38">mdi-close</v-icon>
      </button>

      <div class="help-video-dialog__heading">
        <div class="help-video-dialog__icon" aria-hidden="true">
          <v-icon color="white" size="48">mdi-play-circle-outline</v-icon>
        </div>
        <div>
          <h2>{{ tutorial.title }}</h2>
          <p>Veja o passo a passo para usar o Photo Now.</p>
        </div>
      </div>

      <div class="help-video-dialog__player">
        <video
          v-show="!videoError"
          ref="video"
          :key="videoKey"
          :src="tutorial.videoUrl"
          :poster="tutorial.posterUrl || undefined"
          controls
          playsinline
          preload="metadata"
          @error="videoError = true"
          @loadedmetadata="videoError = false"
        >
          Seu navegador não conseguiu reproduzir o vídeo de ajuda.
        </video>
        <div v-if="videoError" class="help-video-dialog__error" role="alert">
          <v-icon color="#a12622" size="48">mdi-alert-circle-outline</v-icon>
          <p>O vídeo não pôde ser carregado agora.</p>
          <span>Você pode fechar esta janela e continuar normalmente.</span>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "TotemHelpVideoDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    tutorial: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      videoError: false,
    };
  },
  computed: {
    videoKey() {
      return `${this.tutorial.version || "sem-versao"}:${
        this.tutorial.videoUrl
      }`;
    },
  },
  watch: {
    value(isOpen) {
      if (!isOpen) this.resetVideo();
    },
    videoKey() {
      this.videoError = false;
      this.resetVideo();
    },
  },
  beforeDestroy() {
    this.resetVideo();
  },
  methods: {
    close() {
      this.resetVideo();
      this.$emit("input", false);
    },
    resetVideo() {
      const video = this.$refs.video;
      if (!video) return;
      try {
        video.pause();
        video.currentTime = 0;
      } catch (error) {
        // O player é complementar. Falhas do navegador não podem parar o Totem.
        console.warn("Não foi possível reiniciar o vídeo de ajuda.", error);
      }
    },
  },
};
</script>

<style scoped>
.help-video-dialog {
  border-radius: 30px !important;
  color: #2c3763;
  padding: 38px;
  position: relative;
}

.help-video-dialog__close {
  background: #f5f3f8;
  border: 0;
  border-radius: 50%;
  height: 58px;
  position: absolute;
  right: 22px;
  top: 20px;
  width: 58px;
  z-index: 1;
}

.help-video-dialog__heading {
  align-items: center;
  display: flex;
  gap: 20px;
  padding-right: 70px;
}

.help-video-dialog__icon {
  align-items: center;
  background: #ff006b;
  border-radius: 50%;
  display: flex;
  flex: 0 0 auto;
  height: 78px;
  justify-content: center;
  width: 78px;
}

.help-video-dialog h2 {
  font-size: 34px;
  line-height: 1.15;
  margin: 0 0 6px;
}

.help-video-dialog__heading p {
  font-size: 20px;
  margin: 0;
}

.help-video-dialog__player {
  align-items: center;
  background: #11131c;
  border-radius: 22px;
  display: flex;
  justify-content: center;
  margin-top: 28px;
  min-height: 420px;
  overflow: hidden;
}

.help-video-dialog video {
  display: block;
  max-height: 68vh;
  width: 100%;
}

.help-video-dialog__error {
  align-items: center;
  background: #fff7f7;
  color: #7a211e;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 420px;
  padding: 44px;
  text-align: center;
  width: 100%;
}

.help-video-dialog__error p {
  font-size: 26px;
  font-weight: 700;
  margin: 18px 0 8px;
}

.help-video-dialog__error span {
  font-size: 19px;
}
</style>
